import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { TextField, withStyles } from '@material-ui/core'
import i18n from 'support/i18n'
import Button from '@material-ui/core/Button'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import styles from './View.Style'

class FeedbackView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      feedbackMessage: '',
      checkedValue: '',
      // returnInvestment: false,
    }
    this.handleTextFieldChange = this.handleTextFieldChange.bind(this)
    this.handleOnClick = this.handleOnClick.bind(this)
    this.handleOnCLickOnCheck = this.handleOnCLickOnCheck.bind(this)
  }

  handleTextFieldChange(event) {
    const { value } = event.target
    this.setState({ feedbackMessage: value })
  }

  handleOnClick(feedbackMessage) {
    const { id, onClick } = this.props
    onClick(id, feedbackMessage)
  }

  handleOnCLickOnCheck(event) {
    const { value } = event.target
    const { checkedValue } = this.state

    if (checkedValue === value) {
      this.setState({ feedbackMessage: '', checkedValue: '' })
    } else {
      this.setState({ feedbackMessage: value, checkedValue: value })
    }
  }

  render() {
    const { classes, cancelButtonAction } = this.props
    const { feedbackMessage } = this.state
    return (
      <div className={classes.dialogBox}>
        <DialogTitle id="alert-dialog-title">{i18n.t('CONFIRMATION_FEEDBACK_MESSAGE')}</DialogTitle>
        <DialogContent>
          {/* <span dangerouslySetInnerHTML={{ __html: i18n.t('EXPLORE_IDEA.APPROVE_MSG') }} /> */}
          {/* <div>
            <RadioGroup value={checkedValue}>
              {rejectedReasons.data.length > 0 &&
                rejectedReasons.data.map(reason => {
                  return (
                    <FormControlLabel
                      control={<NxtRadio />}
                      onClick={this.handleOnCLickOnCheck}
                      label={
                        <div>
                          <p>{reason.title}</p>
                          <small>{reason.text}</small>
                        </div>
                      }
                      value={`${reason.title}\r${reason.text}`}
                    />
                  )
                })}
            </RadioGroup>
          </div> */}
          <TextField
            color="primary"
            id="filled-multiline-static"
            fullWidth
            label={i18n.t('IDEA.MESSAGE')}
            multiline
            onChange={this.handleTextFieldChange}
            rows="4"
            margin="normal"
            value={feedbackMessage}
            variant="filled"
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.handleOnClick(feedbackMessage)}
          >
            {i18n.t('ACCEPT')}
          </Button>
          <Button variant="contained" color="secondary" onClick={cancelButtonAction}>
            {i18n.t('CANCEL')}
          </Button>
        </DialogActions>
      </div>
    )
  }
}

FeedbackView.defaultProps = {
  id: '',
  rejectedReasons: {},
}

FeedbackView.propTypes = {
  id: PropTypes.string,
  rejectedReasons: PropTypes.shape({}),
  onClick: PropTypes.func.isRequired,
  cancelButtonAction: PropTypes.func.isRequired,
}

export default withStyles(styles)(FeedbackView)
